<template>
	<page>
		<listTemplate page-title="HowToPlayDetail" :pid="pid" type="detail"></listTemplate>

	</page>
</template>

<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate
		},
		data() {
			return {
				pid: null,
			}
		},
		created() {
			const id = this.$route.query.id;
			this.pid = id
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/english/PlayStay/HowToPlayDetail.vue